export enum ObservationAction {
    OPEN_EDIT = '0',
    BLIND_EDIT = '1',
    NUDGE = '2',
    PRINT = '3',
    CHANGE_SCHOOL_YEAR = '4',
    CHANGE_EVALUATOR = '5',
    DELETE = '6',
    REINSTATE = '7',
    REOPEN = '8',
    DUPLICATE = '9',
    CHANGE_SLO_STATUS = '3301'
}